/**
 * Visibilité UI Laika (widget + page).
 * Suit le feature flag LAIKA (+ override env local FORCE).
 */
export function resolveAssistantUiEnabled(params: {
  featureFlagEnabled: boolean;
  forceLaikaEnv?: boolean;
}): boolean {
  if (params.forceLaikaEnv) {
    return true;
  }
  return params.featureFlagEnabled;
}
